/**
 * EFFECTS LIBRARY
 * FANZ
 * DECEMBER 2013
 */

function AddFormRequiredFieldIndicators(){
	
	$('form .requiredField label').append(': <span class="required-field">required</span>');
}

$(document).ready( function() {
	
	AddFormRequiredFieldIndicators();

});